// Persistent debug breadcrumb logger for the hotel-modify → /price/review → Stripe →
// POST /trips/hotels/rebook/confirm flow. Each step is appended to a localStorage array
// so the trace SURVIVES the cross-origin Stripe redirect, any /onboarding auth-redirect,
// and full page reloads — the browser console is cleared on every navigation unless
// DevTools "Preserve log" is on, which makes console-only debugging unreliable here.
//
// Dump the trace from the browser console at any time:   __dumpRebookLog()
// Clear it before a fresh test run:                      __clearRebookLog()
//
// TEMPORARY DIAGNOSTIC — remove once root-caused (grep "rebookLog" / "rebookDebugLog"
// / "REBOOK-DBG").

const KEY = "_rebook_debug_log";
const MAX_ENTRIES = 300;

export function rebookLog(step: string, data?: unknown): void {
  let entry: Record<string, unknown>;
  try {
    entry = { t: Date.now(), iso: new Date().toISOString(), step, data: data ?? null };
  } catch {
    entry = { step, data: data ?? null };
  }
  try {
    let arr: unknown[] = [];
    try {
      arr = JSON.parse(localStorage.getItem(KEY) || "[]");
    } catch {
      arr = [];
    }
    if (!Array.isArray(arr)) arr = [];
    arr.push(entry);
    if (arr.length > MAX_ENTRIES) arr = arr.slice(arr.length - MAX_ENTRIES);
    localStorage.setItem(KEY, JSON.stringify(arr));
  } catch {
    // localStorage blocked/full — fall through to console only.
  }
  try {
    console.log("[REBOOK-DBG]", step, data ?? "");
  } catch {}
}

export function dumpRebookLog(): unknown[] {
  try {
    const arr = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

export function clearRebookLog(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {}
}

// Expose on window for one-liner console dumping after a cross-origin / reload round-trip.
if (typeof window !== "undefined") {
  (window as unknown as Record<string, unknown>).__dumpRebookLog = dumpRebookLog;
  (window as unknown as Record<string, unknown>).__clearRebookLog = clearRebookLog;
}
